import { useEffect, useState } from 'react'
import Layout from '@/components/Layout'
import { fetchZones } from '@/lib/api'
import type { Zone } from '@/lib/types'

export default function ZonesList() {
  const [zones, setZones] = useState<Zone[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchZones().then(setZones).catch(() => {}).finally(() => setLoading(false))
  }, [])

  const zoneLinks: Record<string, string> = {
    sharjah: 'https://partsmarket.pages.dev/used-parts-sharjah/',
    ajman: 'https://partsmarket.pages.dev/used-parts-ajman/',
    'al-quoz': 'https://partsmarket.pages.dev/used-parts-al-quoz/',
  }

  return (
    <Layout title="Zones">
      <div className="max-w-5xl mx-auto space-y-5">
        <p className="text-sm text-slate-500">
          The 3 used-parts hubs of the UAE. Content (hero, intro, areas, FAQs) is edited in the site data files — this view shows the live hubs.
        </p>
        {loading ? (
          <p className="text-slate-400 text-sm text-center py-10">Loading...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {zones.map(z => (
              <div key={z.id} className="bg-white rounded-2xl border border-surface-200 shadow-card p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-surface-100 text-xs font-bold text-slate-600">{z.code}</span>
                  <span className="text-[10px] font-semibold text-slate-400">sort {z.sort_order}</span>
                </div>
                <h3 className="font-semibold text-slate-900">{z.name}</h3>
                <p className="text-xs text-slate-500 mt-2 leading-relaxed line-clamp-3">{z.hero_description}</p>
                <div className="mt-4 pt-3 border-t border-surface-100 flex items-center justify-between">
                  <span className="text-[10px] font-semibold text-slate-400">{Array.isArray(z.areas) ? z.areas.length : 0} areas · {Array.isArray(z.faqs) ? z.faqs.length : 0} FAQs</span>
                  {zoneLinks[z.slug] && (
                    <a href={zoneLinks[z.slug]} target="_blank" rel="noreferrer" className="text-xs font-semibold text-brand-600 hover:text-brand-700 inline-flex items-center gap-1">
                      View page
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/></svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  )
}
